export const config = {
  apiUrl: 'https://api.sellernode.com'
};
